export default __webpack_public_path__ + "static/media/kanye-project-image.9091fb3a.png";